/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

// import { setLastRoute } from '../../core/helpers/lastRoute';
import { useUtils } from '../../core/hooks/useUtils';
import { addUserToTeamAction, getTeamsAction } from '../../store/Teams/action';

interface IOutput {
	isLoaded: boolean;
	isLoading: boolean;
	team: any;
	joinTeam: () => void;
}

interface HookState {
	isLoading: boolean;
}

export default function useHook(): IOutput {
	const {
		dispatch,
		store: { teams },
	} = useUtils();

	const [state, setState] = useState<HookState>({
		isLoading: false,
	});

	const team = teams?.data[0];

	useEffect(() => {
		// setLastRoute('Join');
		if (!teams.isLoaded) {
			dispatch(getTeamsAction());
		}
	}, []);

	const toogleLoader = () => {
		setState(prev => ({ ...prev, isLoading: !prev.isLoading }));
	};

	const joinTeam = (): void => {
		toogleLoader();
		dispatch(addUserToTeamAction({ team, callback: toogleLoader }));
	};

	const { isLoading } = state;

	return {
		isLoaded: teams.isLoaded,
		isLoading,
		team,
		joinTeam,
	};
}
